<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="名称" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="手机号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="所属部门" prop="departmentCode" style="margin-right:15px">
        <groupSelect ref="groupSelect" @setGroupCode="setGroupCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import groupSelect from "./groupSelect";
export default {
  name: "PartyEdit",
  components: {
    groupSelect
  },
  data() {
    // 校验手机号
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][0-9]{10}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("格式有误"));
      } else {
        callback();
      }
    };
    return {
      emptyForm: {},
      form: {
        name: "",
        phone: "",
        branchCode: "",
        departmentCode: "",
        teamCode: "",
        roleCodeList: []
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        departmentCode: [
          { required: true, message: "请选择所属部门", trigger: "blur" }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }]
      }
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    setGroupCode(value) {
      this.form.branchCode = value[0];
      this.form.departmentCode = value[1];
      this.form.teamCode = value[2];
    },
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({ url: `/ntocc-basic-api/staffs/${code}`, method: "get" }).then(
        response => {
          this.form = JSON.parse(JSON.stringify(response.data));
          this.groupSelectValue = [];
          if (this.form.branchCode != "")
            this.groupSelectValue.push(this.form.branchCode);
          if (this.form.departmentCode != "")
            this.groupSelectValue.push(this.form.departmentCode);
          if (this.form.teamCode != "")
            this.groupSelectValue.push(this.form.teamCode);
          this.$refs.groupSelect.setSelectValue(this.groupSelectValue);
        }
      );
    },

    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({ url: "/ntocc-basic-api/staffs", method: "put", data }).then(
            response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherEditMethod");
            }
          );
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
